import { buildLink } from '@amazeelabs/react-framework-bridge/gatsby';
import { graphql } from 'gatsby';

export const TopicListItem = graphql`
  fragment TopicListItem on DrupalTopic {
    title
    path
    drupalId
    depth
  }
`;

type Item = TopicListItemFragment | undefined;

const mapTopicListItemFragments = (
  items: Item[] | undefined,
  filter: (item: Item) => boolean,
) =>
  items
    ?.filter((topic) => topic && filter(topic))
    .map((topic) => ({
      id: topic!.drupalId,
      title: topic!.title,
      Link: buildLink({ href: topic!.path || '/' }),
    })) || [];

export const mapTopicListItemFragmentsToMainTopics = (
  items: Item[] | undefined,
) => mapTopicListItemFragments(items, (topic) => topic?.depth === 0);

export const mapTopicListItemFragmentsToSubTopics = (
  items: Item[] | undefined,
) =>
  mapTopicListItemFragments(
    items,
    (topic) => !!(topic?.depth && topic.depth > 0),
  );
